// src/attach-icon.tsx
import { createSvgIcon } from "@mui/material";
import { jsx } from "react/jsx-runtime";
var AttachIcon = createSvgIcon(
  /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M17.625 15.875c0 1.56-.547 2.887-1.643 3.983C14.887 20.953 13.56 21.5 12 21.5s-2.887-.547-3.982-1.642c-1.096-1.096-1.643-2.423-1.643-3.983V7.55c0-1.125.394-2.081 1.181-2.869C8.344 3.894 9.3 3.5 10.425 3.5c1.125 0 2.081.394 2.869 1.181.787.788 1.181 1.744 1.181 2.869v7.875c0 .69-.24 1.275-.72 1.755s-1.065.72-1.755.72-1.275-.24-1.755-.72a2.388 2.388 0 0 1-.72-1.755V7.1h1.8v8.325A.656.656 0 0 0 12 16.1a.656.656 0 0 0 .675-.675V7.55a2.274 2.274 0 0 0-.664-1.598c-.427-.434-.956-.652-1.586-.652-.63 0-1.163.218-1.598.652a2.173 2.173 0 0 0-.652 1.598v8.325c-.015 1.065.352 1.969 1.102 2.711.75.743 1.658 1.114 2.723 1.114 1.05 0 1.943-.371 2.678-1.114.734-.742 1.117-1.646 1.147-2.711V7.1h1.8v8.775Z"
    }
  ) }),
  "AttachIcon"
);

export {
  AttachIcon
};
